import { Button, HStack, Text } from '@chakra-ui/react';
import { LuDownload } from 'react-icons/lu';

import { TAgentMetadata } from '@/types/agents';
import { handleDownload } from '@/utils/output';

const FileOutput = ({ metadata, isLoading, outputKey }: { metadata: TAgentMetadata | null; isLoading: boolean; outputKey: string }) => {
  return (
    <HStack justify="flex-start" alignSelf="flex-start">
      {!isLoading && (
        <>
          <HStack align="center" mb={2}>
            <Text fontSize="sm" color="fg.muted" mr={3}>
              {metadata?.output?.[outputKey].fileName}
            </Text>
            <Button
              size="sm"
              variant="ghost"
              onClick={() => handleDownload(metadata?.output?.[outputKey].downloadUrl || '', metadata?.output?.[outputKey].fileName || '')}
              color="purple.fg"
              py="2px"
              px="8px"
            >
              <LuDownload />
              Download File
            </Button>
          </HStack>
        </>
      )}
    </HStack>
  );
};

export default FileOutput;
